export const dictionary = {
	youtube: "youtube",
	music: "music",
	spotify: "spotify",
	home: "home",
	admin: "admin",
};
